module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Install HoneyMoney":"Установите ХаниМани","Tap":"Щёлкните","add_to_home_screen":"Выберите <b>На экран «Домой»</b>","Bee Saving!":"С Вами пчёлы!"},"en":{"add_to_home_screen":"Select <b>Add to Home Screen</b>"}}')
  delete Component.options._Ctor
}
